import { adminRepositories } from "data/admin/repositories";

export const paymentPlansRepo = {
  list(params) {
    return adminRepositories.paymentPlans.list(params);
  },
  getById(id) {
    return adminRepositories.paymentPlans.getById(id);
  },
  create(item) {
    return adminRepositories.paymentPlans.create(item);
  },
  update(id, patch) {
    return adminRepositories.paymentPlans.update(id, patch);
  },
  remove(id) {
    return adminRepositories.paymentPlans.remove(id);
  },
};

export const travelCmsRepo = {
  flights: adminRepositories.travelFlights,
  buses: adminRepositories.travelBuses,
  hotels: adminRepositories.travelHotels,
  tours: adminRepositories.travelTours,
  cars: adminRepositories.travelCars,
};

export const appConfigRepo = {
  list() {
    return adminRepositories.appConfig.list({ includeDeleted: true });
  },
  getMobile() {
    return adminRepositories.appConfig.getById("mobile");
  },
  saveMobile(patch) {
    const existing = adminRepositories.appConfig.getById("mobile");
    if (existing) {
      return adminRepositories.appConfig.update("mobile", patch);
    }
    return adminRepositories.appConfig.create({ id: "mobile", ...patch });
  },
};
